import { useState, useEffect } from 'react';

export function usePendingJobsCount(isAdmin: boolean) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAdmin) {
      setCount(0);
      setLoading(false);
      return;
    }

    const fetchCount = async () => {
      try {
        const response = await fetch('/api/admin/jobs?status=pending', { credentials: 'include' });
        if (response.ok) {
          const data = await response.json();
          setCount(data.jobs?.length || 0);
        } else {
          setCount(0);
        }
      } catch {
        setCount(0);
      } finally {
        setLoading(false);
      }
    };

    // Delay first fetch so session/cookies are available (avoids 401 on initial load)
    const timeoutId = setTimeout(fetchCount, 300);
    const intervalId = setInterval(fetchCount, 30000);
    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [isAdmin]);

  return { count, loading };
}
